/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React, { useState } from 'react';
import PropTypes from 'prop-types';

const ModalWrapper = (props) => {
  const { type, id, modal } = props;
  // allow modals to save state that will survive unmounting and re-rendering; see target/detailCard for example
  const [modalState, saveModalState] = useState({});

  const modalProps = modal && {
    ...modal.props,
    modalState,
    saveModalState,
    modalId: id,
    isOpen: modal.open,
    tab: modal.tab,
    onClose: () => props.close(type.name, id)
  };
  const ModalComponent = type && type.component;

  return ModalComponent ? <ModalComponent {...modalProps} /> : null;
};

ModalWrapper.propTypes = {
  id: PropTypes.string,
  modal: PropTypes.object,
  type: PropTypes.object,
  close: PropTypes.func
};

export default ModalWrapper;
